// React is auto-imported with JSX transform
import { motion } from 'framer-motion';

interface CategoryLoadingIndicatorProps {
  isLoading: boolean;
}

export function CategoryLoadingIndicator({ isLoading }: CategoryLoadingIndicatorProps) {
  if (!isLoading) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="w-full h-16 flex items-center justify-center my-4"
    >
      <div className="flex items-center space-x-2">
        {/* Animated dots */}
        <div className="flex space-x-1">
          {[0, 1, 2].map((index) => (
            <motion.div
              key={index}
              initial={{ scale: 0.6, opacity: 0.4 }}
              animate={{ 
                scale: [0.6, 1, 0.6],
                opacity: [0.4, 1, 0.4] 
              }}
              transition={{
                duration: 1.2,
                repeat: Infinity,
                delay: index * 0.2,
                ease: "easeInOut"
              }}
              className="w-3 h-3 bg-[#c9fffc] rounded-full"
            />
          ))}
        </div>
        
        {/* Text */}
        <motion.p 
          className="text-[#c9fffc] text-sm font-medium"
          initial={{ opacity: 0.7 }}
          animate={{ opacity: [0.7, 1, 0.7] }}
          transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
        >
          Loading messages...
        </motion.p>
      </div>
    </motion.div>
  );
}
